module.exports = __webpack_public_path__ + "img/aim.57a37dca.svg";